import { useTranslate } from "helpers";
import { memo } from "react";
import { ContactNoteSearchTabProps } from "./types";
import { NoResults } from "ui/components/NoResults";
import ContactNoteSearchResults from "./components/ContactNoteSearchResults/ContactNoteSearchResults";

const ContactNoteSearchTab: React.FC<ContactNoteSearchTabProps> = (props) => {
  const { searchResults, isLoading, onRowClick, onDeleteClick } = props;

  const { t } = useTranslate();

  return (
    <div className="mx-[-1px]">
      {!isLoading && searchResults.pagination.totalPages === 0 ? (
        <NoResults message={t("admin.contact.note.search.noresults")} />
      ) : (
        <ContactNoteSearchResults
          searchResults={searchResults}
          selectedRows={[]}
          isLoading={isLoading}
          onRowClick={onRowClick}
          onDeleteClick={onDeleteClick}
        />
      )}
    </div>
  );
};

export default memo(ContactNoteSearchTab);
